var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Administrator as AdministratorModel } from '@/models/Administrator';
import PageHeader from '@/components/page-header/PageHeader';
import { fileToBase64, formatDate } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import { Token } from '@/support/Token';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import ErrorHandler from '@/support/ErrorHandler';
import { excludeRoles } from '@/support/ExcludeRoles';
import { cloneDeep } from 'lodash';
import { RolesEnum } from '@/items/Roles';
import ConfirmRemoveMfaDialog from '@/components/ConfirmRemoveMfaDialog/ConfirmRemoveMfaDialog.vue';
let Administrator = class Administrator extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Administrator';
        this.isEditing = false;
        this.isEditingDob = false;
        this.formatDob = formatDate;
        this.administrator = new AdministratorModel();
        this.administratorClone = new AdministratorModel();
        this.file = null;
        this.baseImage = null;
        this.isChangingAvatar = false;
        this.passwordHidden = true;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
        // #region RemoveMFA
        this.isConfirmRemoveMfaDialogOpen = false;
        // #endregion
    }
    get breadcrumbs() {
        return [{ name: this.$tc('roles.user', 2) }, { name: this.$tc('roles.administrator', 2), path: '/administrators' }, { name: this.administrator.name || '', path: this.$route.path }];
    }
    get canEditProfileFields() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'parnassys_status';
        });
        const status = setting && setting.value;
        if (status === '1') {
            return false;
        }
        if (status === '2') {
            return !(this.administratorClone && this.administratorClone.parnassys_id);
        }
        return true;
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.detail.profile.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() {
        new AdministratorModel()
            .include('token')
            .find(this.$route.params.id)
            .then((administrator) => {
            this.administrator = administrator;
            this.administratorClone = cloneDeep(administrator);
        });
    }
    update() {
        this.isEditing = false;
        if (this.password.new.length === 0) {
            this.resetPassword();
        }
        else {
            this.administrator.password = this.password.new;
        }
        const payload = this.administrator.getPayload();
        if (payload.avatar) {
            delete payload.avatar;
        }
        this.administrator
            .include(['administrator', 'roles'])
            .update(payload)
            .then((administrator) => {
            this.resetPassword();
            this.administrator = administrator;
            this.administrator = cloneDeep(administrator);
            this.updateCurrentUser(administrator);
        });
    }
    resetPassword() {
        delete this.administrator.password;
        delete this.administrator.current_password;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
    }
    updateCurrentUser(administrator) {
        if (administrator.id === this.$store.state.Auth.id) {
            this.$store.dispatch('userAuthenticated', administrator);
        }
    }
    setToken() {
        Token.set(this.administrator.token.bearer);
        const url = `${window.location.protocol}//${window.location.host}`;
        window.location.href = url;
    }
    changeAvatar(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        this.file = event.target.files[0];
        fileToBase64(this.file).then((encodedFile) => {
            this.baseImage = encodedFile;
            this.isChangingAvatar = true;
        });
    }
    async changingCurrentAvatar() {
        const adminWithDataObjects = await new AdministratorModel()
            .include(['data_objects'])
            .find(this.$route.params.id);
        if (adminWithDataObjects) {
            this.baseImage = adminWithDataObjects.data_objects.avatar;
            this.isChangingAvatar = true;
        }
    }
    avatarChanged(imageUrl) {
        this.administrator
            .include(['administrator', 'roles'])
            .update({ avatar: imageUrl })
            .then((administrator) => {
            this.administrator.avatar = imageUrl;
            this.updateCurrentUser(administrator);
            this.administrator = cloneDeep(administrator);
            this.$emit('closed', false);
            this.isChangingAvatar = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]);
    }
    get canRemoveMfa() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get removeMfaEnabled() {
        return !!this.administrator.has_mfa_token;
    }
    async removeMfa() {
        if (this.administrator) {
            const administrator = await this.administrator
                .update({ mfa_token: null })
                .catch((error) => {
                ErrorHandler.network(error);
                return null;
            });
            if (administrator) {
                this.$set(this.administrator, 'has_mfa_token', false);
                if (this.administratorClone) {
                    this.$set(this.administratorClone, 'has_mfa_token', false);
                }
            }
        }
        this.isConfirmRemoveMfaDialogOpen = false;
    }
};
Administrator = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            ImageInput,
            ConfirmRemoveMfaDialog,
        },
    })
], Administrator);
export default Administrator;
